import { Check, BookOpen } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { BOOK_ART, BOOK_CTA, BOOK_PHOTOS, FEATURED_BOOK } from "@/lib/books";

const BookCover = ({ src }) => (
  <motion.img
    src={src} alt="Learning to Swim with Mimi hardcover book"
    initial={{ y: 20, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
    className="w-full max-w-[520px] mx-auto rounded-3xl object-cover"
    style={{ boxShadow: "0 30px 60px rgba(11,27,61,0.22)" }}
    data-testid="book-cover"
  />
);

const PhotoGrid = () =>
  BOOK_PHOTOS.length ? (
    <div className="space-y-4" data-testid="book-photos">
      <BookCover src={BOOK_PHOTOS[0].src} />
      {BOOK_PHOTOS.length > 1 && (
        <div className="grid grid-cols-2 gap-4">
          {BOOK_PHOTOS.slice(1).map((p) => (
            <figure key={p.src} className="rounded-2xl overflow-hidden bg-white border" style={{ borderColor: "rgba(212,175,55,0.3)" }}>
              <img src={p.src} alt={p.caption} className="w-full h-full object-cover" />
              {p.caption && <figcaption className="px-4 py-3 font-body text-xs" style={{ color: "var(--muted)" }}>{p.caption}</figcaption>}
            </figure>
          ))}
        </div>
      )}
    </div>
  ) : (
    <div className="relative rounded-3xl overflow-hidden border" style={{ borderColor: "rgba(212,175,55,0.3)", backgroundColor: "#FBF8F1" }} data-testid="book-photos-placeholder">
      <img src={BOOK_ART.openBook} alt="Watercolor illustration of an open storybook" className="w-full aspect-square object-cover" />
      <p className="absolute bottom-5 left-0 right-0 text-center font-body text-xs tracking-[0.2em] uppercase" style={{ color: "var(--navy)" }}>
        Book photos &amp; sample pages coming soon
      </p>
    </div>
  );

export const BookShowcase = () => (
  <section className="py-24" style={{ backgroundColor: "#FBF8F1" }} data-testid="featured-book">
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal><PhotoGrid /></Reveal>
      <Reveal delay={0.1}>
        <p className="overline mb-4" style={{ color: "var(--gold)" }}>The signature storybook</p>
        <h2 className="font-display text-4xl md:text-5xl leading-tight" style={{ color: "var(--navy)" }} data-testid="featured-book-title">{FEATURED_BOOK.title}</h2>
        <p className="font-display italic text-xl mt-3" style={{ color: "var(--turquoise)" }}>{FEATURED_BOOK.subtitle}</p>
        <p className="font-body font-light leading-relaxed mt-6" style={{ color: "var(--muted)" }}>{FEATURED_BOOK.description}</p>
        <p className="overline mt-8 mb-4" style={{ color: "var(--navy)" }}>{FEATURED_BOOK.personalizedTitle}</p>
        <ul className="space-y-3" data-testid="featured-book-personalized">
          {FEATURED_BOOK.details.map((d) => (
            <li key={d} className="flex items-start gap-3 font-body text-sm" style={{ color: "var(--navy)" }}>
              <Check size={18} className="mt-0.5 shrink-0" style={{ color: "var(--turquoise)" }} /> {d}
            </li>
          ))}
        </ul>
        <p className="font-body text-xs italic mt-5" style={{ color: "var(--muted)" }}>{FEATURED_BOOK.note}</p>
        <a href="#book-request" className="btn-primary mt-10 inline-flex" data-testid="featured-book-cta"><BookOpen size={18} /> {BOOK_CTA}</a>
      </Reveal>
    </div>
  </section>
);
